import { render } from "./TablePythagore.vue?vue&type=template&id=0cbcf76b&scoped=true"
import script from "./TablePythagore.vue?vue&type=script&lang=js"
export * from "./TablePythagore.vue?vue&type=script&lang=js"

import "./TablePythagore.vue?vue&type=style&index=0&id=0cbcf76b&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbcf76b"]])

export default __exports__